import { ButtonVariant } from "@amzn/stencil-react-components/button";
import { Row } from "@amzn/stencil-react-components/layout";
import { Pagination } from "@amzn/stencil-react-components/pagination";
import { H3, Text } from "@amzn/stencil-react-components/text";
import { Button } from "@amzn/uxm-stencil-react-components/lib/src/stencil/button";
import React, { FC, ReactNode, RefObject } from "react";

import { USE_CASES_PAGINATION_PAGE_COUNT } from "../constants";

interface UseCaseSectionProps {
  title: string;
  totalCount?: number;
  isHidden: boolean;
  isExpanded: boolean;
  children: ReactNode;
  sentinelRef?: RefObject<HTMLDivElement>;
  numberOfPages?: number;
  page: number;
  onPageSelect: (page: number) => void;
  paginationAriaLabel: string;
  exploreLabel: string;
  exploreTouchpoint: string;
  onExplore: () => void;
  exploreVariant?: ButtonVariant;
  collapseLabel?: string;
  collapseTouchpoint?: string;
  onCollapse?: () => void;
}

export const UseCaseSection: FC<UseCaseSectionProps> = ({
  title,
  totalCount,
  isHidden,
  isExpanded,
  children,
  sentinelRef,
  numberOfPages = USE_CASES_PAGINATION_PAGE_COUNT,
  page,
  onPageSelect,
  paginationAriaLabel,
  exploreLabel,
  exploreTouchpoint,
  onExplore,
  exploreVariant = ButtonVariant.Tertiary,
  collapseLabel,
  collapseTouchpoint,
  onCollapse,
}) => (
  <section
    className={`use-case-browse-page__section use-case-browse-page__section--animated${
      isHidden ? " use-case-browse-page__section--hidden" : ""
    }${isExpanded ? " use-case-browse-page__section--expanded" : ""}`}
  >
    <div className={isExpanded ? "use-case-browse-page__section-header--sticky" : undefined}>
      <Row gridGap="dimensions.spacing.200" alignItems="baseline" justifyContent="space-between">
        {isExpanded && onCollapse && collapseLabel && collapseTouchpoint && (
          <Button variant={ButtonVariant.Tertiary} touchpoint={collapseTouchpoint} onClick={onCollapse}>
            {collapseLabel}
          </Button>
        )}
        <Row gridGap="dimensions.spacing.200" alignItems="baseline">
          <H3>{title}</H3>
          {isExpanded && totalCount !== undefined && (
            <Text fontSize="T200" color="color.text.secondary">
              ({totalCount})
            </Text>
          )}
        </Row>
      </Row>
    </div>
    <div className="use-case-browse-page__grid">{children}</div>
    {isExpanded && sentinelRef && <div ref={sentinelRef} style={{ height: 20 }} />}
    {!isExpanded && (
      <div className="use-case-browse-page__pagination">
        <Pagination
          numberOfPages={numberOfPages}
          selectedPage={page}
          onPageSelect={onPageSelect}
          aria-label={paginationAriaLabel}
        />
      </div>
    )}
    {!isExpanded && (
      <Row justifyContent="center" padding={{ top: "dimensions.spacing.200" }}>
        <Button variant={exploreVariant} touchpoint={exploreTouchpoint} onClick={onExplore}>
          {exploreLabel}
        </Button>
      </Row>
    )}
  </section>
);
